export default __webpack_public_path__ + "static/media/2_rupee.9c403279.svg";